import {Users} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const PeopleIcon = createLucideIcon(Users, 'PeopleIcon');
